/**
 * Gets the proper image URL based on the image path with cache-busting
 * @param imagePath - The image path from the server
 * @param fallbackImage - The fallback image to use if the image is not found
 * @returns The full image URL with cache-busting parameter
 */
export const getImageUrl = (imagePath?: string | null, fallbackImage: string = '/placeholder-book.png') => {
  // Added additional null check
  if (!imagePath) {
    console.log('Image path is empty, using fallback:', fallbackImage);
    return fallbackImage;
  }
  
  // If the image is a Cloudinary URL
  if (imagePath.startsWith('http')) {
    // Add cache-busting parameter with current timestamp
    const cacheBuster = `?t=${Date.now()}`;
    return imagePath.includes('?') ? `${imagePath}&t=${Date.now()}` : `${imagePath}${cacheBuster}`;
  }
  
  // Fallback to local path
  if (imagePath.startsWith('/')) {
    return `${imagePath}?t=${Date.now()}`;
  }
  
  // Otherwise, assume it's a relative path
  console.log('Using relative path');
  return `/uploads/${imagePath}?t=${Date.now()}`;
};

/**
 * Creates an image onError handler that sets the src to a fallback image
 * @param fallbackImage - The fallback image to use
 * @returns An onError handler function
 */
export const handleImageError = (fallbackImage: string = '/placeholder-book.png') => {
  return (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.error('Image failed to load:', e.currentTarget.src);
    e.currentTarget.src = fallbackImage;
  };
};